import { createContext, useContext, useReducer, useCallback } from 'react';

const TOUR_STORAGE_KEY = 'stellar_tour_completed';

const TourContext = createContext(null);

const initialState = {
  active: false,
  stepIndex: 0,
};

function tourReducer(state, action) {
  switch (action.type) {
    case 'START_TOUR':
      return { active: true, stepIndex: 0 };
    case 'NEXT_STEP':
      return { ...state, stepIndex: state.stepIndex + 1 };
    case 'PREV_STEP':
      return { ...state, stepIndex: Math.max(0, state.stepIndex - 1) };
    case 'END_TOUR':
      return { active: false, stepIndex: 0 };
    default:
      return state;
  }
}

export function TourProvider({ children }) {
  const [state, dispatch] = useReducer(tourReducer, initialState);

  const startTour = useCallback(() => {
    dispatch({ type: 'START_TOUR' });
  }, []);

  const nextStep = useCallback(() => {
    dispatch({ type: 'NEXT_STEP' });
  }, []);

  const prevStep = useCallback(() => {
    dispatch({ type: 'PREV_STEP' });
  }, []);

  const endTour = useCallback(() => {
    dispatch({ type: 'END_TOUR' });
    try {
      localStorage.setItem(TOUR_STORAGE_KEY, 'true');
    } catch {}
  }, []);

  const hasCompletedTour = useCallback(() => {
    try {
      return localStorage.getItem(TOUR_STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  }, []);

  const value = {
    ...state,
    startTour,
    nextStep,
    prevStep,
    endTour,
    hasCompletedTour,
  };

  return (
    <TourContext.Provider value={value}>
      {children}
    </TourContext.Provider>
  );
}

export function useTour() {
  const context = useContext(TourContext);
  if (context === null) {
    throw new Error('useTour must be used within a TourProvider');
  }
  return context;
}
